import { Typography } from '@musinsa/mds';
import type { FC } from 'react';
import { SalesRankingMonthSelector } from './SalesRankingMonthSelector';
import { LastUpdatedTime } from './SalesRankingOrderBySelector/LastUpdatedTime';
import { OrderBySelector } from './SalesRankingOrderBySelector/OrderBySelector';
import { RankingDescription } from './SalesRankingOrderBySelector/RankingDescription';

export const SalesRankingFilterSection: FC = () => (
  <section>
    <SalesRankingMonthSelector />
    <div className="px-4 py-3 text-base-gray-9 flex items-center justify-between space-x-5">
      <Typography variant="body13pxReg" className="inline-flex items-center space-x-0.5">
        <LastUpdatedTime />
        <RankingDescription />
      </Typography>
      <OrderBySelector />
    </div>
  </section>
);
